module.exports = __webpack_public_path__ + "static/naninator_logo-c28f431772008a04b34f0b2cb8b6c5f3.png";